import { useAuth } from '../context/AuthContext';

export function Dashboard() {
  const { user } = useAuth();
  
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Welcome, {user?.first_name || 'User'}!</h2>
        <p className="text-gray-600">
          You have successfully authenticated with both factors:
        </p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li className="text-green-600">✓ Password authentication completed</li>
          <li className="text-green-600">✓ Biometric verification completed</li>
        </ul>
      </div>
      
      <div className="bg-white shadow-md rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Your Profile</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-gray-500 text-sm">Name</p>
            <p>{user?.first_name} {user?.last_name}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Email</p>
            <p>{user?.email}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Role</p>
            <p>{user?.role || 'User'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}